// OUTSeriesTransformer.tsx
import * as React from "react";
import "./index.css"
import { parseView } from "./swmmjs_module";

// This is the new problem. I need to read the dataType from the
// parent object, not write it to the parent object. This element
// is only for updating the series object.
const OUTSeriesTransformer = ({values, outbin, onChange}: any) => {
  
  React.useEffect(() => {
    // Keep the number of data points down for these types of visualizations.
    let maxPeriods = 500
    let dataSet:any[] = []
    let seriesGroup:any[] = []
    if (values.type != '' 
        && values.objNames.length > 0
        && outbin.byteLength > 0){
      values.objNames.forEach((el:string) => {
        let series = parseView(outbin, values.type, el, values.dataType, maxPeriods, values.startPeriod, values.endPeriod)
        seriesGroup.push(series)
        let data = Array()
        // If dataSet is empty, push objects with the time into it.
        if(dataSet.length === 0){
          series.forEach(el => {
            data.push({
              time: el[0].getTime()
            })
          } )
          dataSet = data
        }
      } )
      seriesGroup.forEach((series, i)=>{
        dataSet.forEach((el, j)=>{
          dataSet[j] = {...el, [values.objNames[i]]: series[j][1]}
        })
      })
      
      onChange({name: 'series', value: dataSet})
    } else if (values.type === 'SYS' 
      && outbin.byteLength > 0){
      let series = parseView(outbin, values.type, 0, values.dataType, maxPeriods, values.startPeriod, values.endPeriod)
      seriesGroup.push(series)
      let data = Array()
      // If dataSet is empty, push objects with the time into it.
      if(dataSet.length === 0){
        series.forEach(el => {
          data.push({
            time: el[0].getTime()
          })
        } )
        dataSet = data
      }
    seriesGroup.forEach((series, i)=>{
      dataSet.forEach((el, j)=>{
        dataSet[j] = {...el, ['SYS']: series[j][1]}
      })
    })
    
    onChange({name: 'series', value: dataSet})
  }
  }, [values.type, values.objNames, outbin])

  return(
    <></>
  )
};
 
export {OUTSeriesTransformer};